import { render } from "./TasksList.vue?vue&type=template&id=4fe2f66c&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=4fe2f66c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fe2f66c"

export default script